export default __webpack_public_path__ + "static/media/mail-foreground.cadb9b6a.png";